/*
 * @Author:
 * @LastEditTime: 2022-11-02 11:51:52
 * @Description: 弹窗可拖拽
 */
import Vue from 'vue'

// v-dialogDrag: 弹窗拖拽属性
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    Vue.nextTick(() => {
      const dialogHeaderEl = el.querySelector('.el-dialog__header')
      const dragDom = el.querySelector('.el-dialog')
      dialogHeaderEl.style.cssText += ';cursor:move;'
      dragDom.style.cssText += ';top:0px;'
      // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
      const sty = (function () {
        if (window.document.currentStyle) {
          return (dom, attr) => { return dom.currentStyle[attr] }
        }
        return (dom, attr) => { return getComputedStyle(dom, false)[attr] }
      }())

      dialogHeaderEl.onmousedown = (e) => {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - dialogHeaderEl.offsetLeft
        const disY = e.clientY - dialogHeaderEl.offsetTop

        const screenWidth = document.body.clientWidth // body当前宽度
        const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)

        const dragDomWidth = dragDom.offsetWidth // 对话框宽度
        const dragDomheight = dragDom.offsetHeight // 对话框高度

        const minDragDomLeft = dragDom.offsetLeft
        const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

        const minDragDomTop = dragDom.offsetTop
        const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight

        // 获取到的值带px 正则匹配替换
        let styL = sty(dragDom, 'left')
        let styT = sty(dragDom, 'top')

        // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
        if (styL.includes('%')) {
          styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100)
          styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100)
        } else {
          styL = +styL.replace(/\px/g, '')
          styT = +styT.replace(/\px/g, '')
        }

        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let left = e.clientX - disX
          let top = e.clientY - disY

          // 边界处理
          if (-left > minDragDomLeft) {
            left = -minDragDomLeft
          } else if (left > maxDragDomLeft) {
            left = maxDragDomLeft
          }

          if (-top > minDragDomTop) {
            top = -minDragDomTop
          } else if (top > maxDragDomTop) {
            top = maxDragDomTop
          }

          // 移动当前元素
          dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
        }

        document.onmouseup = function (e) {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
      window.onresize = () => {
        console.log(window.devicePixelRatio)
      }
    })
  },
  update(el) {
    if (el.parentNode.style.display !== 'none') {
      function dialogResize() {
        const dialog = el.children[0]
        dialog.style.height = null
        if (dialog.offsetTop + dialog.offsetHeight - 50 > document.body.offsetHeight) {
          dialog.style.height = '85%'
        }
      }
      dialogResize()
      window.onresize = () => {
        dialogResize()
      }
    } else {
      window.onresize = null
    }
  }
})
// v-drag: 元素拖拽，不限制元素类型

Vue.directive('drag', {
  bind(el) {
    const odiv = el // 获取当前元素
    el.onmousedown = (e) => {
      if (e.button === 0) {
        // 阻止穿透
        e.stopPropagation()
        // 无需触发拖动的元素
        const className = ['el-slider__button', 'icon-close', 'el-input__inner']
        // 算出鼠标相对元素的位置
        if (!_.isEmpty(_.intersection(className, e.target.className.split(' ')))) {
          return
        }
        // 获取点击元素路径列表
        const ePathList = e.path
        // 是否被'height-routerView'包裹
        const isRouterView = _.findIndex(ePathList, (item) => {
          return item.className === 'h-100 height-routerView'
        })
        const sliderWidth = isRouterView === -1 ? 0 : 200
        const sliderHeight = isRouterView === -1 ? 0 : 90
        const disX = e.clientX - odiv.offsetLeft
        const disY = e.clientY - odiv.offsetTop
        let left = ''
        let top = ''
        document.onmousemove = (e) => {
          // 阻止穿透
          e.stopPropagation()
          // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          left = e.clientX - disX
          top = e.clientY - disY
          // 绑定元素位置到positionX和positionY上面
          // 移动当前元素
          if (left < 0) {
            left = 0
          } else if (left > document.documentElement.clientWidth - odiv.offsetWidth - sliderWidth) {
            left = document.documentElement.clientWidth - odiv.offsetWidth - sliderWidth
          }
          if (top < 45) {
            top = 45
          } else if (
            top >
            document.documentElement.clientHeight - odiv.offsetHeight - sliderHeight
          ) {
            top = document.documentElement.clientHeight - odiv.offsetHeight - sliderHeight
          }
          odiv.style.left = `${left}px`
          odiv.style.top = `${top}px`
        }
      }
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
        document.onmouseout = null
      }
    }
  },
})

// v-selectloadmore：el-select下拉框触底加载
Vue.directive('selectloadmore', {
  bind(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', () => {
      /**
       * scrollHeight 获取元素内容高度(只读)
       *scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0
       *clientHeight 读取元素的可见高度(只读)
       *如果元素滚动到底, 下面等式返回true, 没有则返回false
       *ele.scrollHeight - ele.scrollTop === ele.clientHeight
       */
      const condition =
        SELECTWRAP_DOM.scrollHeight - SELECTWRAP_DOM.scrollTop <= SELECTWRAP_DOM.clientHeight
      if (condition) binding.value()
    })
  },
})
